import * as React from 'react';
import ModalContactThankYou from '../../src/containers/ContactThankYou/index';

export default (props) => <ModalContactThankYou {...props} />
